import z from 'zod';
import { zDateField } from '../utils/date.utils.js';
export const accountingPeriodWithRelations = {
    include: {
        commitee: {
            select: {
                id: true,
                name: true,
            },
        },
    },
};
export const AccountingPeriodStatusValues = {
    current: 'current',
    temporarilyClosed: 'temporarilyClosed',
    closed: 'closed',
};
export const AccountingPeriodStatusSchema = z.enum(Object.values(AccountingPeriodStatusValues), {
    message: 'Le statut de la période comptable est requis',
});
export const isAccountingPeriodStatus = (status) => {
    return AccountingPeriodStatusSchema.safeParse(status).success;
};
export const accountingPeriodDataSchema = z
    .object({
    name: z.string().min(1, 'Le nom est requis'),
    startDate: zDateField('La date de début est requise'),
    endDate: zDateField('La date de fin est requise'),
    status: AccountingPeriodStatusSchema,
})
    .refine((data) => !data.startDate || !data.endDate || data.startDate < data.endDate, {
    message: 'La date de début doit être antérieure à la date de fin',
    path: ['endDate'],
});
// Past exercices are allowed: a FEC covers the previous one (older ones when taking over books) and
// every imported écriture must land in an exercice. Bounded to catch typos.
const ACCOUNTING_PERIOD_PAST_YEARS = 10;
const ACCOUNTING_PERIOD_FUTURE_YEARS = 1;
export function getAccountingPeriodBounds(now = new Date()) {
    const currentYear = now.getUTCFullYear();
    const minYear = currentYear - ACCOUNTING_PERIOD_PAST_YEARS;
    const maxYear = currentYear + ACCOUNTING_PERIOD_FUTURE_YEARS;
    return {
        minStartDate: new Date(Date.UTC(minYear, 0, 1)),
        maxEndDate: new Date(Date.UTC(maxYear, 11, 31)),
        minYear,
        maxYear,
    };
}
export const CLOSURE_CHECK_DETAILS_LIMIT = 200;
